import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import Table from 'components/table/SimpleTable'
import Image from 'components/widgets/Image'

import routerActions from 'store/modules/router'
import projectActions from 'store/modules/project'
import projectSelectors from 'store/selectors/project'

import {
  projectUrl,
  fullUrl,
} from 'utils/url'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
  },
  title: {
    flexGrow: 1,
  },
  addButton: {
    flexGrow: 0,
  },
  actionButton: {
    margin: theme.spacing(1),
  },
  logo: {
    width: '100px',
    border: '1px solid #000',
  },
  colorSquare: {
    width: '20px',
    height: '20px',
    border: '1px solid #000',
  }
}))

const FIELDS = [{
  title: '',
  name: 'color',
}, {
  title: '',
  name: 'logo',
}, {
  title: 'Name',
  name: 'name',
}, {
  title: 'URL',
  name: 'url',
}, {
  title: 'Description',
  name: 'description',
}]

const Home = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  
  const projects = useSelector(projectSelectors.projects)
  
  const onView = useCallback((account) => {
    dispatch(routerActions.navigateTo('book.list', {
      project: projectUrl(account),
    }))
  })

  const tableData = useMemo(() => {
    return projects.map(project => {
      const url = fullUrl(project)
      return {
        id: project.id,
        rawUrl: project.url || project.id,
        name: project.name,
        project,
        color: project.meta.color && project.meta.color.color && (
          <div
            className={ classes.colorSquare }
            style={{
              backgroundColor: project.meta.color.color,
            }}
          ></div>
        ),
        logo: (
          <Image
            className={ classes.logo }
            data={ project.meta.logo }
          />
        ),
        description: (
          <Typography variant="caption" className={ classes.description }>
            { project.meta.description }
          </Typography>
        ),
        url: (
          <a
            href={ url }
            onClick={ (e) => {
              e.preventDefault()
              onView(project)
            }}
          >
            { url }
          </a>
        )
      }
    })
  }, [
    projects,
  ])

  const getActions = useCallback((item) => {
    return (
      <>
        <Button
          className={ classes.actionButton }
          size="small"
          variant="outlined"
          onClick={ (e) => {
            onView(item.project)
            return false
          }}
        >
          View
        </Button>
      </>
    )
  })

  useEffect(() => {
    dispatch(projectActions.loadPublicProjects())
  }, [])

  return (
    <div className={ classes.root }>
      <div className={ classes.toolbar }>
        <div className={ classes.title }>
          <Typography gutterBottom variant="h6">
            Booking Projects
          </Typography>
        </div>
      </div>
      <div className={ classes.content }>
        <Table
          data={ tableData }
          fields={ FIELDS }
          getActions={ getActions }
        />
      </div>
    </div>
  )
}

export default Home